import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  z-index: 9;\n\n  .ant-tabs {\n    display: block;\n    background-color: #ff4c11;\n\n    .ant-tabs-nav {\n      max-width: 996px;\n      height: 72px;\n      margin: 0 auto;\n\n      @media (max-width: 1200px) {\n        height: 64px;\n      }\n      @media (max-width: 768px) {\n        height: 56px;\n\n        & > * {\n          display: none;\n\n          &.ant-tabs-nav-wrap {\n            display: block;\n          }\n        }\n      }\n\n      .ant-tabs-nav-wrap {\n        .ant-tabs-nav-list {\n          position: relative;\n          display: flex;\n          width: 100%;\n\n          .ant-tabs-tab {\n            flex: 1;\n            text-align: center;\n            padding: 0;\n\n            .ant-tabs-tab-btn {\n              width: 100%;\n              height: 100%;\n              font-size: 24px;\n              font-weight: normal;\n              color: rgba(255, 255, 255, 0.7);\n              line-height: 70px;\n              padding: 0 30px;\n\n              &[aria-selected='false']:hover {\n                opacity: 0.7;\n              }\n            }\n\n            &.ant-tabs-tab-active {\n              .ant-tabs-tab-btn {\n                font-weight: bold;\n                color: #fff;\n              }\n            }\n\n            @media (max-width: 1200px) {\n              margin-left: 0;\n\n              .ant-tabs-tab-btn {\n                font-size: 20px;\n                line-height: 56px;\n              }\n            }\n            @media (max-width: 768px) {\n              .ant-tabs-tab-btn {\n                font-size: 16px;\n              }\n            }\n          }\n\n          .ant-tabs-ink-bar {\n            position: absolute;\n            bottom: 0;\n            display: inline-block;\n            width: 14px !important;\n            height: 14px;\n            margin-left: 25%;\n            transform: translate(-50%, 50%) rotate(135deg);\n            background-color: #fff;\n          }\n        }\n      }\n    }\n\n    .ant-tabs-content-holder {\n      .ant-tabs-content {\n        .ant-tabs-tabpane {\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  background-color: #fdfdff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 76px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Tabs } from "antd";
import styled from "styled-components";
import { RNumberView } from "@/modules/landings/protection/components/RNumberView";
import { ProtectDescriptionView } from "@/modules/landings/protection/components/ProtectDescriptionView";
const onChange = (key)=>{
    ;
};
const RAuthTabWrapper = styled.div.withConfig({
    componentId: "sc-e13438e9-0"
})(_templateObject());
const Wrapper = styled.div.withConfig({
    componentId: "sc-e13438e9-1"
})(_templateObject1());
export const ProtectTab = (props)=>{
    return /*#__PURE__*/ _jsx(RAuthTabWrapper, {
        children: /*#__PURE__*/ _jsxs(Tabs, {
            defaultActiveKey: "1",
            children: [
                /*#__PURE__*/ _jsx(Tabs.TabPane, {
                    tab: "R인증이란?",
                    children: /*#__PURE__*/ _jsx(ProtectDescriptionView, {})
                }, "1"),
                /*#__PURE__*/ _jsx(Tabs.TabPane, {
                    tab: "R인증 번호 조회",
                    children: /*#__PURE__*/ _jsx(Wrapper, {
                        children: /*#__PURE__*/ _jsx(RNumberView, {})
                    })
                }, "2")
            ]
        })
    });
};
